import { Component, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { EUserFunctionality, IUser } from 'src/app/modules/shared/models/user';
import { DashboardService } from 'src/app/pages/dashboard/dashboard.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoggerService } from 'src/app/services/logger.service';
import { SidenavService } from '../sidenav/sidenav.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {

  destroy$ = new Subject();

  constructor(
    private readonly _authenticationService: AuthenticationService,
    private readonly _dashboardService: DashboardService,
    private readonly _sidenavService: SidenavService,
    private readonly _router: Router
  ) { }

  ngOnInit(): void {
  }

  toggleSidenav() {
    this._sidenavService.toggle();
  }

  get thereArePendingOperations(): boolean {
    return this._dashboardService.thereArePendingOperations;
  }

  getFunctionalityBadge(mode: string): string {
    switch (mode) {
      case EUserFunctionality.W:
        return 'badge-green';
      case EUserFunctionality.R:
        return 'badge-yellow';
      case EUserFunctionality.HD:
      default:
        return 'badge-red';
    }
  }

  getFunctionalityLabel(mode: string): string {
    switch (mode) {
      case EUserFunctionality.W:
        return 'Piena operatività';
      case EUserFunctionality.R:
        return 'Sola lettura';
      case EUserFunctionality.HD:
        return 'Help Desk';
      default:
        return 'Non abilitato';
    }
  }

  get user(): IUser {
    return this._authenticationService.loggedUser;
  }

  get ibipMode(): string {
    return this._authenticationService.ibipMode;
  }

  get noIbipMode(): string {
    return this._authenticationService.noIbipMode;
  }

  get prevPipMode(): string {
    return this._authenticationService.prevPipMode;
  }

  get headquarterType(): string {
    return this.user?.isFuoriSede ? "Fuori sede" : "In sede";
  }

  get isBcp(): boolean {
    return this.user?.isCesarePonti;
  }

  goToDashboard() {
    LoggerService.logInfo(this.constructor.name, 'goToDashboard');
    this._router.navigate(['/dashboard'], {
      state: {
        filterByUser: true
      }
    })
  }

  getCorporateLogo(): string {
    if (this.isBcp) {
      return 'assets/images/logo-bcp.png';
    }
    return 'assets/images/bper-logo-white.svg';
  }

}
